import styled from "styled-components";

export const FormContainer = styled.div`
    width: 90%;
    max-width: 400px;
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    gap: 10px;
    display: flex;
    flex-direction: column;

`

export const FormHeader = styled.div`
    text-align: center;
    padding: 10px;
`

export const FormContent = styled.div`
    width: 100%;
`

export const FormActions = styled.div`
    width: 100%;
    margin-top: 10px;
`
